import { render, staticRenderFns } from "./ExamSelector.vue?vue&type=template&id=32301a02&"
import script from "./ExamSelector.vue?vue&type=script&lang=js&"
export * from "./ExamSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports